import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';
import { COLORS } from '../theme';
import { setLetterboxColor } from '../utils/letterbox';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create() {
    const { STAGE_W, STAGE_H } = GAME_CONFIG;
    setLetterboxColor(COLORS.ink);
    this.add.rectangle(0, 0, STAGE_W, STAGE_H, COLORS.ink).setOrigin(0, 0);
    const title = this.add.text(STAGE_W / 2, STAGE_H / 2 - 20, 'Yodajjom Dance', {
      fontFamily: 'sans-serif',
      fontSize: '40px',
      color: '#ffffff',
    });
    title.setOrigin(0.5);
    const sub = this.add.text(STAGE_W / 2, STAGE_H / 2 + 30, 'Starting…', {
      fontFamily: 'sans-serif',
      fontSize: '20px',
      color: '#9be7ff',
    });
    sub.setOrigin(0.5);

    this.time.delayedCall(500, () => this.scene.start('PreloadScene'));
  }
}
